import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_PARKING_CATEGORIES,
  CPM_ADD_CARPARK_PARKING_CATEGORY,
  CPM_UPDATE_CARPARK_PARKING_CATEGORY,
  CPM_DELETE_CARPARK_PARKING_CATEGORY,
  CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY,
  CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY,
  CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/parkingCategory';
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkParkingCategory;
const cpmCarparkParkingCategory = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (
        action.target === 'fullCarpark'
        || action.target === 'currentCarpark'
      ) {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          addPriceGrid: { ...initialSettings.addPriceGrid },
          deletePriceGrid: { ...initialSettings.deletePriceGrid },
          sendPriceGridToCustomer: { ...initialSettings.sendPriceGridToCustomer },
        };
      }
      switch (action.target) {
        case 'addCarparkParkingCategory':
          key = 'add';
          break;
        case 'updateCarparkParkingCategory':
          key = 'update';
          break;
        case 'deleteCarparkParkingCategory':
          key = 'delete';
          break;
        case 'addCarparkPriceGridParkingCategory':
          key = 'addPriceGrid';
          break;
        case 'deleteCarparkPriceGridParkingCategory':
          key = 'deletePriceGrid';
          break;
        case 'sendCarparkPriceGridToCustomer':
          key = 'sendPriceGridToCustomer';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST PARKING CATEGORIES
    case CPM_GET_CARPARK_PARKING_CATEGORIES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case `${CPM_GET_CARPARK_PARKING_CATEGORIES}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_PARKING_CATEGORIES}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.listParkingCategories),
          loading: false,
        },
      };
    // ADD PARKING CATEGORY
    case CPM_ADD_CARPARK_PARKING_CATEGORY:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_PARKING_CATEGORY}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_PARKING_CATEGORY}_SUCCESS`:
      mutationResult = action.data.addParkingCategory;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // UPDATE PARKING CATEGORY
    case CPM_UPDATE_CARPARK_PARKING_CATEGORY:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_PARKING_CATEGORY}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_PARKING_CATEGORY}_SUCCESS`:
      mutationResult = action.data.updateParkingCategory;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // DELETE PARKING CATEGORY
    case CPM_DELETE_CARPARK_PARKING_CATEGORY:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_PARKING_CATEGORY}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_PARKING_CATEGORY}_SUCCESS`:
      mutationResult = action.data.deleteParkingCategory;
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // ADD PRICE GRID TO PARKING CATEGORY
    case CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY:
      return {
        ...state,
        addPriceGrid: {
          ...state.addPriceGrid,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY}_ERROR`:
      return {
        ...state,
        addPriceGrid: {
          ...state.addPriceGrid,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY}_SUCCESS`:
      mutationResult = action.data.addPriceGridToParkingCategory;
      return {
        ...state,
        addPriceGrid: {
          ...state.addPriceGrid,
          added: true,
          result: {
            id: _toFinite(action.parkingCategoryId),
            operation: deserializeOperation(mutationResult),
          },
        },
      };
    // DELETE PRICE GRID FROM PARKING CATEGORY
    case CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY:
      return {
        ...state,
        deletePriceGrid: {
          ...state.deletePriceGrid,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY}_ERROR`:
      return {
        ...state,
        deletePriceGrid: {
          ...state.deletePriceGrid,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY}_SUCCESS`:
      mutationResult = action.data.deletePriceGridFromParkingCategory;
      return {
        ...state,
        deletePriceGrid: {
          ...state.deletePriceGrid,
          deleted: true,
          result: {
            id: _toFinite(action.parkingCategoryId),
            operation: deserializeOperation(mutationResult),
          },
        },
      };
    // SEND PRICE GRID TO CUSTOMER
    case CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER:
      return {
        ...state,
        sendPriceGridToCustomer: {
          ...state.sendPriceGridToCustomer,
          sent: false,
          error: null,
        },
      };
    case `${CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER}_ERROR`:
      return {
        ...state,
        sendPriceGridToCustomer: {
          ...state.sendPriceGridToCustomer,
          error: action.error,
        },
      };
    case `${CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER}_SUCCESS`:
      return {
        ...state,
        sendPriceGridToCustomer: {
          ...state.sendPriceGridToCustomer,
          sent: true,
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkParkingCategory;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkParkingCategory.js